var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ea5660d339c604882144cfffbfab4c53c3eb8ecf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@orava-web"]={id:"ea5660d339c604882144cfffbfab4c53c3eb8ecf"};
      